import api from "../../infra/api";

class ServConsultaDeAcesso {
    async listar(codigoResp, pesquisaGeral) {
        let url = `/api/v1/ConsultaDeAcesso?page=1&start=0&limit=999&fields=["Id","CodigoResponsavelTecnico","CodigoTipoGeracao","DataCadastro","FatorPotencia","Latitude","Longitude","NumeroEnd","PrazoAnalise","Protocolo","Situacao","TipoConexao","TipoInscricao","TipoGeracao.Descricao","Nome","CodigoUC","Inscricao","Complemento","TensaoAtendimento","PotenciaInstalada","CodigoAnaliseAtual"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false}]`;

        if (pesquisaGeral.trim() !== "") {
            url = url.slice(0, -1);
            url += `,{"property":"Nome","operator":"containsall","value":"${pesquisaGeral}"},{"property":"Inscricao","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Protocolo","value":"${pesquisaGeral}","and":false},{"property":"CodigoUC","value":"${pesquisaGeral}","and":false},{"property":"Id","value":"${pesquisaGeral}","and":false}]`;
        }

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    async listarCfeSituacaoOuData(codigoResp, pesquisaGeral, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let filter = this.retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, situacao, tipoDataFiltro, dataInicial, dataFinal);
        let url = filter.trim() === "" ?
            `/api/v1/ConsultaDeAcesso?page=1&start=0&limit=999&fields=["Id","CodigoResponsavelTecnico","CodigoTipoGeracao","DataCadastro","FatorPotencia","Latitude","Longitude","NumeroEnd","PrazoAnalise","Protocolo","Situacao","TipoConexao","TipoInscricao","TipoGeracao.Descricao","Nome","CodigoUC","Inscricao","Complemento","TensaoAtendimento","PotenciaInstalada","CodigoCidade","CodigoAnaliseAtual"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false}]` :
            `/api/v1/ConsultaDeAcesso?page=1&start=0&limit=999&fields=["Id","CodigoResponsavelTecnico","CodigoTipoGeracao","DataCadastro","FatorPotencia","Latitude","Longitude","NumeroEnd","PrazoAnalise","Protocolo","Situacao","TipoConexao","TipoInscricao","TipoGeracao.Descricao","Nome","CodigoUC","Inscricao","Complemento","TensaoAtendimento","PotenciaInstalada","CodigoCidade","CodigoAnaliseAtual"]&sort=[{"property":"Id","direction":"DESC"}]&filter=${filter}`

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    retornaFilterDeAcordoComFiltros(codigoResp, pesquisaGeral, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temPesquisaGeral = pesquisaGeral.trim() !== "";

        if (temPesquisaGeral) {
            let filtroSituacaoDatas = this.handleFiltrosSituacaoOuDatas(codigoResp, situacao, tipoDataFiltro, dataInicial, dataFinal);
            let filtroFinal = "," + filtroSituacaoDatas.slice(1);

            return `[{"property":"Id","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"Nome","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"Inscricao","operator":"containsall","value":"${pesquisaGeral}","and":false},{"property":"CodigoUC","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"Protocolo","operator":"equal","value":"${pesquisaGeral}","and":false},{"property":"CodigoResponsavelTecnico","operator":"equal","value":${codigoResp},"and":true,"not":false}` + filtroFinal;
        } else {
            return this.handleFiltrosSituacaoOuDatas(codigoResp, situacao, tipoDataFiltro, dataInicial, dataFinal);
        }
    }

    handleFiltrosSituacaoOuDatas(codigoResp, situacao, tipoDataFiltro, dataInicial, dataFinal) {
        let temSituacaoInformada = situacao.length > 0;
        let temPeriodoInformado = (dataInicial && dataInicial.toLocaleDateString() !== "") && (dataFinal && dataFinal.toLocaleDateString() !== "");
        let arraySituacaoFormatada = JSON.stringify(situacao);
        let campoParaFiltrarData = (tipoDataFiltro === "data-cadastro") ? "DataCadastro" : "DataEnvioSolicitacao";

        if (temSituacaoInformada && !temPeriodoInformado) {
            return `[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false}]`
        } else if (!temSituacaoInformada && temPeriodoInformado) {
            return `[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial.toLocaleDateString()}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal.toLocaleDateString()}","and":true}]`
        } else {
            return `[{"property":"CodigoResponsavelTecnico","operator":"equal","value":"${codigoResp}","and":true,"not":false},{"property":"Situacao","operator":"in","value":${arraySituacaoFormatada},"and":true,"not":false},{"property":"${campoParaFiltrarData}","operator":"greaterOrEqual","value":"${dataInicial ? dataInicial.toLocaleDateString() : "01/01/1900"}","and":true},{"property":"${campoParaFiltrarData}","operator":"lessOrEqual","value":"${dataFinal ? dataFinal.toLocaleDateString() : "01/01/1900"}","and":true}]`
        }
    }

    async Inserir(dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/ConsultaDeAcesso",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async Editar(dto) {
        const response = await api({
            method: "PUT",
            url: `api/v1/ConsultaDeAcesso/${dto.Id}`,
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RecuperarParaEditar(codigoConsulta) {
        const response = await api({
            method: "GET",
            url: `api/v1/ConsultaDeAcesso/${codigoConsulta}/RecuperarParaEditar`
        });

        return response.data;
    }

    async EnviarParaAnalise(codigoConsulta) {
        const response = await api({
            method: "PUT",
            url: `api/v1/ConsultaDeAcesso/${codigoConsulta}/EnviarParaAnalise`
        });

        return response.data;
    }

    async ArquivarConsultaDeAcesso(dto) {
        const response = await api({
            method: "PUT",
            url: "api/v1/ConsultaDeAcesso/ArquivamentoRealizadoPeloResponsavelTecnico",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async RecuperarArquivamento(codigoConsulta) {
        const response = await api({
            method: "GET",
            url: `api/v1/ConsultaDeAcesso/RecuperarArquivamento/${codigoConsulta}`
        });

        return response.data;
    }

    async RecuperarUCs(filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? "api/v1/UC/?page=1&start=0&limit=25"
                : `api/v1/UC/?page=1&start=0&limit=2&filter=[{"property":"Id","operator":"containsall","value":"${filtro}","and":false}]`
        });

        return response.data;
    }

    async RecuperarTipoGeracao(filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `api/v1/TipoGeracao?page=1&start=0&limit=999&fields=["Id","Fonte","Descricao"]`
                : `api/v1/TipoGeracao?page=1&start=0&limit=999&fields=["Id","Fonte","Descricao"]&filter=[{"property":"Descricao","operator":"containsall","value":"${filtro}","and":false}]`
        });

        return response.data;
    }

    async RecuperarCidades(filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `api/v1/Cidades?page=1&start=0&limit=999&fields=["Id","Nome"]&sort=[{"property":"Id","direction":"ASC"}]`
                : `api/v1/Cidades?page=1&start=0&limit=999&fields=["Id","Nome"]&sort=[{"property":"Id","direction":"ASC"}]&filter=[{"property":"Nome","operator":"containsall","value":"${filtro}","and":false}]`
        });

        return response.data;
    }

    async RecuperarAnaliseConsultaDeAcesso(codigoConsulta) {
        const response = await api({
            method: "GET",
            url: `api/v1/ConsultaDeAcessoAnalise/RecuperarAnaliseConsultaDeAcesso/${codigoConsulta}`
        });

        return response.data;
    }

    async VisualizarDocumentoParecer(codigoConsulta) {
        const response = await api({
            method: "GET",
            url: `api/v1/ConsultaDeAcessoAnalise/VisualizarDocumentoParecer/${codigoConsulta}`
        });

        return response.data;
    }

    async CarregarDadosDoConsumidor(dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/UC/DadosDoConsumidor",
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async InserirDocumentoNaConsulta(form) {
        const response = await api({
            method: "POST",
            url: "api/v1/ConsultaDeAcesso/AdicionarAnexoNaConsulta",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: form
        });

        return response.data;
    }

    async RealizarDownloadDocumento(codigoDocumento) {
        const response = await api({
            method: "POST",
            url: "api/v1/ConsultaDeAcesso/RealizarDownloadDocumento",
            data: {
                CodigoDocumento: codigoDocumento
            }
        });

        return response.data;
    }
    async ObterCoordenadasUtmParaGraus(codigoUc) {

        const response = await api({
            method: "GET",
            url: `api/v1/ConsultaDeAcesso/ObterCoordenadasUtmParaGraus/${codigoUc ?? null}`
        });

        return response.data;
    }

    async RecuperarCidadePadrao() {
        const response = await api({
            method: "GET",
            url: "api/v1/ConsultaDeAcesso/RecuperarCidadePadrao"
        });

        return response.data;
    }

    async RecuperarUrlMig() {
        const response = await api({
            method: "GET",
            url: "api/v1/ConsultaDeAcesso/RecuperarUrlMig"
        });

        return response.data;
    }

    async RemoverDocumento(codigoDocumento) {
        const response = await api({
            method: "DELETE",
            url: `api/v1/ConsultaDeAcesso/RemoverAnexoDocs/${codigoDocumento}`
        });

        return response.data;
    }
}

export default new ServConsultaDeAcesso();